import { ReactElement } from "react";
import { Box, BoxProps, Divider, Stack, styled } from "@mui/material";
import { DialogHeader } from "src/components/modal/senec-dialog/SenecDialogHeader";
import { SenecBaseTheme } from "src/styles/senecBaseTheme";
import { SenecLoadingOverlay } from "src/components/feedback/senec-loading-overlay/SenecLoadingOverlay";

export interface SenecDialogContentProps {
    title?: string;
    icon?: ReactElement;
    MainComponent: ReactElement;
    BottomComponent?: ReactElement;
    "data-testid": string;
    onClose: () => void;
    showDivider: boolean;
    showLoader: boolean;
    fillHeight?: boolean;
    onReturn?: () => void;
}

export const SenecDialogContent = ({
    title,
    icon,
    MainComponent,
    BottomComponent,
    onClose,
    "data-testid": dataTestId,
    showDivider,
    showLoader,
    fillHeight = false,
    onReturn = undefined,
}: SenecDialogContentProps) => {
    return (
        <Stack direction={"column"} data-testid={dataTestId} paddingX="1.5rem" sx={{ height: fillHeight ? "100%" : "auto" }}>
            <StickyHeader>
                <DialogHeader onReturn={onReturn} icon={icon} title={title} onClose={onClose} />
                {showDivider && <Divider data-testid={"dialog-divider"} sx={{ marginX: "-1.5rem", marginTop: "1.5rem" }} />}
            </StickyHeader>
            <Box overflow={"auto"} marginBottom={"1.5rem"} position={"relative"} sx={{ flex: fillHeight ? 1 : "unset" }}>
                {MainComponent}
                <SenecLoadingOverlay isVisible={showLoader} />
            </Box>
            {BottomComponent && (
                <StickyFooter>
                    <Divider sx={{ marginX: "-1.5rem" }} />
                    <Box paddingY={"1.5rem"}>{BottomComponent}</Box>
                </StickyFooter>
            )}
        </Stack>
    );
};

export const StickyHeader = styled(Box)<BoxProps>(({ theme }) => {
    const senecBaseTheme = theme as SenecBaseTheme;
    return {
        position: "sticky",
        zIndex: 1,
        top: 0,
        paddingTop: "1.5rem",
        paddingBottom: "1.5rem",
        background: senecBaseTheme.palette.white.main,
    };
});

export const StickyFooter = styled(Box)<BoxProps>(({ theme }) => {
    const senecBaseTheme = theme as SenecBaseTheme;
    return { position: "sticky", zIndex: 1, bottom: 0, background: senecBaseTheme.palette.white.main };
});
